<template>
  <div :class="classes">
    <slot />
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue'
export default defineComponent({
  name: 'AkBadge',
  props: {
    color: {
      type: String,
      default: 'white',
      validator: (v) => {
        return [
          'primary',
          'secondary',
          'tertiary',
          'quaternary',
          'action',
          'info',
          'success',
          'danger',
          'warning',
          'grey',
          'grey-light',
          'grey-lighter',
          'grey-lightest',
          'grey-dark',
          'grey-darker',
          'black',
          'white',
        ].includes(v)
      },
    },
    border: {
      type: String,
      default: 'white',
      validator: (v) => {
        return [
          'none',
          'transparent',
          'primary',
          'secondary',
          'tertiary',
          'quaternary',
          'action',
          'info',
          'success',
          'danger',
          'warning',
          'grey',
          'grey-light',
          'grey-lighter',
          'grey-lightest',
          'grey-dark',
          'grey-darker',
          'black',
          'white',
        ].includes(v)
      },
    },
    size: {
      type: String,
      default: 'default',
      validator: (v) => {
        return ['small', 'default', 'large', 'huge'].includes(v)
      },
    },
    circle: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const classes = computed(() => {
      const styles = [
        'ak-badge',
        `ak-badge--border-${props.border}`,
        `ak-badge--${props.size}`,
        `bg-${props.color}`,
      ]
      if (props.circle) {
        styles.push('ak-badge--circle')
      }
      return styles
    })
    return {
      classes,
    }
  },
})
</script>

<style lang="scss">
@import '../../scss/_settings.scss';
.ak-badge {
  width: 1.25em;
  height: 1.25em;
  border-width: 1px;
  border-style: solid;
  text-align: center;
  font-weight: 700;
  display: inline-block;
  &--circle {
    border-radius: 50%;
  }
  &--default {
    font-size: 0.75em;
  }
  &--small {
    font-size: 50%;
    line-height: 1.2em;
  }
  &--large {
    font-size: 115%;
  }
  &--huge {
    font-size: 150%;
  }
  &--border {
    &-none {
      border: none !important;
    }
    &-white {
      border-color: white;
    }
    &-primary {
      border-color: $color-primary;
    }
    &-secondary {
      border-color: $color-secondary;
    }
    &-tertiary {
      border-color: $color-tertiary;
    }
    &-quaternary {
      border-color: $color-quaternary;
    }
    &-action {
      border-color: $color-action;
    }
    &-info {
      border-color: $color-info;
    }
    &-success {
      border-color: $color-success;
    }
    &-danger {
      border-color: $color-danger;
    }
    &-warning {
      border-color: $color-warning;
    }
    &-grey {
      border-color: $color-grey;
    }
    &-grey-light {
      border-color: $color-grey-light;
    }
    &-grey-lighter {
      border-color: $color-grey-lighter;
    }
    &-grey-lightest {
      border-color: $color-grey-lightest;
    }
    &-grey-dark {
      border-color: $color-grey-dark;
    }
    &-grey-darker {
      border-color: $color-grey-darker;
    }
    &-black {
      border-color: black;
    }
    &-transparent {
      border-color: transparent;
    }
  }
}
</style>
